import { render, staticRenderFns } from "./CompanyProfile_Details.vue?vue&type=template&id=f47513e0&"
import script from "./CompanyProfile_Details.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports